import axios from "axios";
// Action types
export const FETCH_ABOUT_REQUEST = "FETCH_ABOUT_REQUEST";
export const FETCH_ABOUT_SUCCESS = "FETCH_ABOUT_SUCCESS";
export const FETCH_ABOUT_FAILURE = "FETCH_ABOUT_FAILURE";

export const FETCH_FOOTER_REQUEST = "FETCH_FOOTER_REQUEST";
export const FETCH_FOOTER_SUCCESS = "FETCH_FOOTER_SUCCESS";
export const FETCH_FOOTER_FAILURE = "FETCH_FOOTER_FAILURE";

// Action Creators
export const fetchAboutRequest = () => ({
  type: FETCH_ABOUT_REQUEST,
});

export const fetchAboutSuccess = (data) => ({
  type: FETCH_ABOUT_SUCCESS,
  payload: data,
});

export const fetchAboutFailure = (error) => ({
  type: FETCH_ABOUT_FAILURE,
  payload: error,
});

export const fetchFooterRequest = () => ({
  type: FETCH_FOOTER_REQUEST,
});

export const fetchFooterSuccess = (data) => ({
  type: FETCH_FOOTER_SUCCESS,
  payload: data,
});

export const fetchFooterFailure = (error) => ({
  type: FETCH_FOOTER_FAILURE,
  payload: error,
});

// Thunk Action
export const fetchAbout = () => async (dispatch) => {
  dispatch(fetchAboutRequest());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/about`
    );
    dispatch(fetchAboutSuccess(response.data));
  } catch (error) {
    dispatch(fetchAboutFailure(error.message));
  }
};

export const fetchFooter = () => async (dispatch) => {
  dispatch(fetchFooterRequest());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_SERVER_URL}/footer`
    );
    dispatch(fetchFooterSuccess(response.data));
  } catch (error) {
    dispatch(fetchFooterFailure(error.message));
  }
};
